import { cornersToPath } from '~/lib/outline/path'

const isPlainObject = v => !!v && typeof v === 'object' && !Array.isArray(v)

/** A `w`×`h` box as vector `data`, anchored at 0,0 as `resetPathOrigin` leaves it. */
export const boxData = (w, h) =>
	cornersToPath([
		[0, 0],
		[w, 0],
		[w, h],
		[0, h],
	])

// A `rect` without `data` (the video node's replacement) becomes the path the rect tool draws: every outline reader needs `data`.
export function rectToPath(settings) {
	const objects = settings?.objects
	if (!isPlainObject(objects)) return settings
	let next = null
	for (const [id, obj] of Object.entries(objects)) {
		if (obj?.type !== 'rect' || obj.data) continue
		next ??= { ...objects }
		next[id] = { ...obj, type: 'path', data: boxData(obj.width ?? 0, obj.height ?? 0) }
	}
	return next ? { ...settings, objects: next } : settings
}

export default rectToPath
